import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as GC from "../../../../common/common";
import NatureProtection from "../../../../common/natureProtection/natureProtection";

export default function standart() {}

export const FillTableCallBack = (result, page_number, columnList) => {
  var oTable = $("#example").dataTable();
  if (page_number === 1) {
    oTable.fnClearTable();
  }
  if (page_number <= result.meta.total_pages) {
    if (result.data.length > 0) {
      $.each(result.data, function (index, data) {
        var circleType = "";
        var checkbox =
          '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';

        var statusBudget =
          data.content["status-budget"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var statusDetailplanning =
          data.content["status-detailplanning"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var statusGlobaleplanning =
          data.content["status-globaleplanning"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';

        var statusVerzonden =
          data.content["status-verzonden"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var statusWerkorder =
          data.content["status-werkorder"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var statusWerkplan =
          data.content["status-werkplan"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var statusUitvoering =
          data.content["status-uitvoering"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var planningIscorrectiefonderhoud =
          data.content["planning-iscorrectiefonderhoud"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        /**iconların bitişi */

        /**diğer alanların başlangıcı */
        var algemeenGisratio = data.content["algemeen-gisratio"];
        if (typeof algemeenGisratio === "undefined") {
          algemeenGisratio = "";
        }
        var status = data.status[0].status;
        if (typeof status === "undefined") {
          status = "";
        }
        var maatregelNaam = data.content["maatregel-naam"];
        if (typeof maatregelNaam === "undefined") {
          maatregelNaam = "";
        }
        var beheeractiviteitLaag = data.content["beheeractiviteit-laag"];
        if (typeof beheeractiviteitLaag === "undefined") {
          beheeractiviteitLaag = "";
        }
        var beheereenheidNaam = data.content["beheereenheid-naam"];
        if (typeof beheereenheidNaam === "undefined") {
          beheereenheidNaam = "";
        }
        var disciplineNaam = data.content["discipline-naam"];
        if (typeof disciplineNaam === "undefined") {
          disciplineNaam = "";
        }
        var statusTijdstipVerzonden = data.content["status-tijdstip_verzonden"];
        if (typeof statusTijdstipVerzonden === "undefined") {
          statusTijdstipVerzonden = "";
        } else statusTijdstipVerzonden = GC.FormatDate(statusTijdstipVerzonden, "date");

        var timestampCreated = data["timestamp_created"];
        if (typeof timestampCreated === "undefined") {
          timestampCreated = "";
        } else timestampCreated = GC.FormatDate(timestampCreated, "date");

        var timestampUpdated = data["timestamp_updated"];
        if (typeof timestampUpdated === "undefined") {
          timestampUpdated = "";
        } else timestampUpdated = GC.FormatDate(timestampUpdated, "date");

        var workPlanName = `<a href='/catalog/work-plans?workplanid=`+ 
        `${data.content["werkplan-identification"]}'>${data.content["werkplan-naam"]}</a>`;
        if (typeof workPlanName === "undefined") {
          workPlanName = "";
        }

        var model = {
          statusBudget: statusBudget,
          statusDetailplanning: statusDetailplanning,
          statusGlobaleplanning: statusGlobaleplanning,
          statusVerzonden: statusVerzonden,
          statusWerkorder: statusWerkorder,
          algemeenGisratio: algemeenGisratio,
          status: status,
          maatregelNaam: maatregelNaam,
          beheereenheidNaam: beheereenheidNaam,
          beheeractiviteitLaag: beheeractiviteitLaag,
          disciplineNaam: disciplineNaam,
          statusTijdstipVerzonden: statusTijdstipVerzonden,
          timestampCreated: timestampCreated,
          timestampUpdated: timestampUpdated,
          identification: data.identification,
          werkplanNaam: data.content["werkplan-naam"],
          werkplanId: data.content["werkplan-id"],
          werkplanIdentification: data.content["werkplan-identification"]
        };

        window.$mm_work_plans_Glist.push(model);

        var test = {
          checkbox: checkbox,
          active: circleType,
          status_detailplanning: statusDetailplanning,
          status_budget: statusBudget,
          status_uitvoering: statusUitvoering,
          status_werkplan: statusWerkplan,
          planning_iscorrectiefonderhoud: planningIscorrectiefonderhoud,
          status_verzonden: statusVerzonden,
          "Gisratio Id": algemeenGisratio,
          Status: status,
          Werkplan: workPlanName,
          "Naam maatregel": maatregelNaam,
          Laag: beheeractiviteitLaag,
          "Naam beheereenheid": beheereenheidNaam,
          "Naam discipline": disciplineNaam,
          "Tijdstip verzonden": statusTijdstipVerzonden,
          "Datum aangemaakt": timestampCreated,
          "Datum laatst gewijzigd": timestampUpdated,
        };

        var _columnList = [];
        for (let column in columnList.column_list) {
          for (let key in test) {
            if (
              columnList.column_list[column].toLowerCase() == key.toLowerCase()
            ) {
              _columnList.push(test[key]);
            }
          }
        }

        var addId = oTable.fnAddData(
          [
            ..._columnList,
            // checkbox,
            // circleType,
            // statusDetailplanning,
            // statusBudget,
            // statusUitvoering,
            // statusWerkplan,
            // planningIscorrectiefonderhoud,
            // statusVerzonden,
            // algemeenGisratio,
            // status,
            // maatregelNaam,
            // beheeractiviteitLaag,
            // beheereenheidNaam,
            // disciplineNaam,
            // statusTijdstipVerzonden,
            // timestampCreated,
            // timestampUpdated,
          ],
          false
        );

        var theNode = $("#example").dataTable().fnSettings().aoData[
          addId[0]
        ].nTr;
        theNode.setAttribute("rowId", data["identification"]);
      });
      oTable.fnDraw();
    } else {
      $("tbody").html();
      oTable.fnClearTable();
    }
  }

  var statusCheck = window.$mm_work_plans_Glist.filter(
    (x) => x.status !== "Akkoord" && x.status !== "Niet Akkoord"
  );

  if (statusCheck.length === 0) {
    window.$mm_work_plans_statusCheck = true;
  } else {
    window.$mm_work_plans_statusCheck = false;
  }

  $("#total-rows").html(result.meta.total_found);
  window.$mm_work_plans_table_total_row_count = result.meta.total_found;
  $("#cover-spin").hide(0);
  window.$mm_work_plans_treeChangeStatus = true;
  window.$mm_work_plans_gvv = 0;
  window.$mm_work_plans_scroll_change = true;
};

export const FillFilterColumnsCallBack = (data, result) => {
  if (data.id === "algemeen-gisratio") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_plannigAlgemeenGisratio.push(data);
    });
  } else if (data.id === "status") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_plannigStatus.push(data);
    });
  } else if (data.id === "maatregel-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_maatregelNaam.push(data);
    });
  } else if (data.id === "werkplan-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_werkplanNaam.push(data);
    });
  } else if (data.id === "planningspatroon-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_planningspatroonNaam.push(data);
    });
  } else if (data.id === "planningsperiode-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_planningsperiodeNaam.push(data);
    });
  } else if (data.id === "budget-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_budgetNaam.push(data);
    });
  } else if (data.id === "beheereenheid-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_beheereenheidNaam.push(data);
    });
  } else if (data.id === "beheeractiviteit-laag") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_beheeractiviteitLaag.push(data);
    });
  } else if (data.id === "discipline-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_disciplineNaam.push(data);
    });
  } else if (data.id === "status-tijdstip_verzonden") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_statusTijdstipVerzonden.push(data);
    });
  }
};

export const SearchFilterColumnsCallBack = (searchId, result) => {
  if (searchId === "algemeen-gisratio") {
    window.$mm_work_plans_plannigAlgemeenGisratio.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_plannigAlgemeenGisratio.push(data);
    });
  } else if (searchId === "status") {
    window.$mm_work_plans_plannigStatus.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_plannigStatus.push(data);
    });
  } else if (searchId === "maatregel-naam") {
    window.$mm_work_plans_maatregelNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_maatregelNaam.push(data);
    });
  } else if (searchId === "werkplan-naam") {
    window.$mm_work_plans_werkplanNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_werkplanNaam.push(data);
    });
  } else if (searchId === "planningspatroon-naam") {
    window.$mm_work_plans_planningspatroonNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_planningspatroonNaam.push(data);
    });
  } else if (searchId === "planningsperiode-naam") {
    window.$mm_work_plans_planningsperiodeNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_planningsperiodeNaam.push(data);
    });
  } else if (searchId === "budget-naam") {
    window.$mm_work_plans_budgetNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_budgetNaam.push(data);
    });
  } else if (searchId === "beheereenheid-naam") {
    window.$mm_work_plans_beheereenheidNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_beheereenheidNaam.push(data);
    });
  } else if (searchId === "beheeractiviteit-laag") {
    window.$mm_work_plans_beheeractiviteitLaag.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_beheeractiviteitLaag.push(data);
    });
  } else if (searchId === "discipline-naam") {
    window.$mm_work_plans_disciplineNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_disciplineNaam.push(data);
    });
  } else if (searchId === "status-tijdstip_verzonden") {
    window.$mm_work_plans_statusTijdstipVerzonden.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_plans_statusTijdstipVerzonden.push(data);
    });
  }
};

export const beheereenheidSavedCallBack = (token) => {
  Common.sleep(800).then(() => {
    var model = {
      action: "ADD",
      contextRol: "Beheereenheid zit in folder",
      folder: document.getElementById("tree-parent-id").value,
    };
    Common.StartActivity(
      model,
      window.$catalog_management_units_newInsertId,
      "708371ee-e3f6-4de7-87f8-dfe94b86f9b1",
      beheereenheidSavedNext(token),
      token
    );
  });
};
function beheereenheidSavedNext(token) {
  Common.sleep(4000).then(() => {
    $("#beheereenheid_toevoegen_modal").modal("hide");
    window.$mm_work_plans_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_management_units_lastUsedTableFilter,
        1,
        token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
}

export const BeheereenheidEditCallBack = (token) => {
  Common.sleep(800).then(() => {
    $("#detailSide").addClass("d-none");
    $("#editSide").addClass("d-none");
    $("#tableSide").removeClass("d-none");
    window.$mm_work_plans_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_management_units_lastUsedTableFilter,
        1,
        token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const RowsDeletedCallBack = (token) => {
  Common.sleep(500).then(() => {
    $("#management-units-mappen_beheren_delete_modal").modal("hide");
    window.$mm_work_plans_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_management_units_lastUsedTableFilter,
        1,
        token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const GetActionsOfRowCallback = (result) => {
  var actionsOfSelection = [];
  var actionsOfDisabled = [];

  /**
   * * seçili statır sayısı getirilir
   */
  window.$mm_work_plans_table_selected_row_count = 0;
  $("#example")
    .dataTable()
    .$("tr.selected")
    .each(function () {
      window.$mm_work_plans_table_selected_row_count++;
    });
  $.each(result.data.stages, function (index, stage) {
    if (stage.definition.type === "activity" && stage.start_allowed === true) {
      actionsOfSelection.push(stage.definition.identification);
    } else {
      actionsOfDisabled.push(stage.definition);
    }
  });
  const popup = $("#myPopup");
  popup.html("");
  $.each(window.$mm_work_plans_actions, function (index, action) {
    if (
      window.$mm_work_plans_lastUsedTableFilter.content[0].values.length === 0
    ) {
      window.$mm_sideMenu_isSubFolderInTreeChildrenContext = false;
    }
    
    if ($.inArray(action["id"], actionsOfSelection) !== -1) {
      if (window.$mm_sideMenu_isSubFolderInTreeChildrenContext === true) {
        var anchor = $("<a></a>")
          .attr({ href: "javascript:void(0)", id: action["id"] })
          .addClass(action["class"] + " mm_work_plans_action")
          .html(action["text"]);
        popup.append(anchor);
      } else {
        if (
          action["id"] !== "56785c54-8059-46ae-8b7f-250ce971a539" ||
          action["modal"] !== "plaats_in_uitvoering"
        ) {
          if ($.inArray(action["id"], actionsOfSelection) !== -1) {
            var anchor = $("<a></a>")
              .attr({ href: "javascript:void(0)", id: action["id"] })
              .addClass(action["class"] + " mm_work_plans_action")
              .html(action["text"]);
            popup.append(anchor);
          }
        }
      }
    }
  });

  const showOnMap = $("<a></a>")
      .attr({ role: "button", id: "wp_toon_dossiers_op_kaart" })
      .addClass("locate action")
      .html("Toon op kaart");
  popup.append(showOnMap);

  if (window.$mm_work_plans_table_selected_row_count > 0){
    const anchor = $("<a></a>")
        .attr({ href: "javascript:void(0)", id:"nature_protection"})
        .addClass("nature-protection-ico mm_work_plans_action")
        .html("Natuurbeschermingscheck");
    popup.append(anchor);
  }

  //** aktif olmayan actionlar burada listeleniyor. */
  // $.each(actionsOfDisabled, function (index, action) {
  //   var anchor = $("<a disabled></a>")
  //     .attr({ href: "javascript:void(0)", id: action["identification"] })
  //     .addClass("disabled" + " catalog-action")
  //     .html(action["name"]);
  //   $("#myPopup").append(anchor);
  // });

  document.getElementById("myPopup").classList.toggle("show");
};

export const WijzigStatusCallback = (result, elementId) => {
  $("#" + elementId).html("");
  $.each(
    result.data.input_data_definition.structure_definition.schema.properties
      .status.enum,
    function (index, row) {
      let checked = row == "Gepland" ? "checked" : "";

      var btn = '<div class="custom-control custom-radio">';
      btn +=
        '<input type="radio" ' +
        checked +
        ' class="custom-control-input" name="wijzig-status"  id="' +
        row +
        '" value="' +
        row +
        '" />';
      btn +=
        '<label class="custom-control-label" for="' +
        row +
        '">' +
        row +
        "</label></div>";
      $("#" + elementId).append(btn);
    }
  );
};

export const UitvoerderCallback = (result) => {
  $("#uitvoerder-grp").html("");
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="uitvoerder"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '" />';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#uitvoerder-grp").append(btn);
  });
};
export const BudgetCallback = (result) => {
  $("#budget-grp").html("");
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="budget"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '" />';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#budget-grp").append(btn);
  });
};
export const PlaatsWerkplanCallback = (result) => {
  $("#plaats-werkplan-grp").html("");
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="plaats-werkplan"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '" />';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#plaats-werkplan-grp").append(btn);
  });
};

export function TableColumnChangeHandler(
  settings,
  data,
  identification,
  columnOrderReference,
  COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT
) {
  var names = settings.aoColumns;
  if (names[0]) {
  }
  var test_list = [];
  names.forEach((element, index) => {
    test_list.push(element.sTitle);
  });

  var checkIndex = test_list.findIndex((x) => x.includes("checkAll"));
  test_list[checkIndex] = "checkbox";

  var statusIndex = test_list.findIndex((x) => x.includes("snowflake"));
  test_list[statusIndex] = "active";

  var status_detailplanningIndex = test_list.findIndex((x) =>
    x.includes("status_detailplanning")
  );
  test_list[status_detailplanningIndex] = "status_detailplanning";
  var status_budgetIndex = test_list.findIndex((x) =>
    x.includes("status_budget")
  );
  test_list[status_budgetIndex] = "status_budget";
  var status_uitvoeringIndex = test_list.findIndex((x) =>
    x.includes("status_uitvoering")
  );
  test_list[status_uitvoeringIndex] = "status_uitvoering";
  var status_werkplanIndex = test_list.findIndex((x) =>
    x.includes("status_werkplan")
  );
  test_list[status_werkplanIndex] = "status_werkplan";
  var planning_iscorrectiefonderhoudIndex = test_list.findIndex((x) =>
    x.includes("planning_iscorrectiefonderhoud")
  );
  test_list[planning_iscorrectiefonderhoudIndex] =
    "planning_iscorrectiefonderhoud";
  var status_verzondenIndex = test_list.findIndex((x) =>
    x.includes("status_verzonden")
  );
  test_list[status_verzondenIndex] = "status_verzonden";

  var model = {
    identification: identification,
    code: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    client_identification: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    reference: columnOrderReference,
    data: {
      table_sorting: [
        {
          name: "management-maintenance>work-plans",
          column_list: [],
        },
      ],
    },
  };
  var asd = (model.data.table_sorting.find(
    (x) => x.name === "management-maintenance>work-plans"
  ).column_list = test_list);
  omnimap.GetFreeFormatAction(identification, "PUT", model);

  return model.data.table_sorting[0];
}
